import { memo, useState } from 'react';
import { useTimeoutWhen } from 'rooks';

import LoadRemote from './LoadRemote';
import { TLazyRemote } from './types';

const ScheduledLoadRemote = ({ scheduleAfter = 0, ...props }: TLazyRemote) => {
  const [shouldWait, setShouldWait] = useState(true);
  useTimeoutWhen(() => setShouldWait(false), scheduleAfter);

  if (shouldWait) return <></>;

  return <LoadRemote {...props} />;
};

export default memo(ScheduledLoadRemote);
